










import { Component, Prop, Vue, Ref } from "vue-property-decorator";

@Component
export default class Help extends Vue {
  async mounted() {}
}
